import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BuildIcon from '@mui/icons-material/Build';
import PaymentsIcon from '@mui/icons-material/Payments';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkHoursList from './WorkHoursList';
import WorkActivitiesList from './WorkActivitiesList';
import PayrollOverview from './PayrollOverview';
import PayrollSettings from './PayrollSettings';
import { useAuth } from '../../hooks/useAuth';

export default function WorkHoursPage() {
  const [tab, setTab] = useState(0);
  const { user } = useAuth();
  const hasPayrollAccess = user?.role === 'SUPERADMIN' || user?.payrollAccess === true;

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab icon={<AccessTimeIcon fontSize="small" />} iconPosition="start" label="Arbejdstimer" />
        <Tab icon={<BuildIcon fontSize="small" />} iconPosition="start" label="Aktiviteter" />
        {hasPayrollAccess && <Tab icon={<PaymentsIcon fontSize="small" />} iconPosition="start" label="Lønoverblik" />}
        {hasPayrollAccess && <Tab icon={<SettingsIcon fontSize="small" />} iconPosition="start" label="Indstillinger" />}
      </Tabs>

      {tab === 0 && <WorkHoursList />}
      {tab === 1 && <WorkActivitiesList />}
      {hasPayrollAccess && tab === 2 && <PayrollOverview />}
      {hasPayrollAccess && tab === 3 && <PayrollSettings />}
    </Box>
  );
}
